export const getBlogBaseLink = (language: string): string => 'https://blog.bake.io/';

const freezerRevampBlog = {
  de: 'eine-der-grossten-uberarbeitungen-in-cake-defis-geschichte',
  it: 'importanti-revisioni',
};

export const getFreezerRevampBlogLink = (language: string): string => `${getBlogBaseLink(language)}/${freezerRevampBlog[language] || 'one-of-the-biggest-revamps-in-cake-defis-history'}`;
